import React from 'react';
import {
  Box, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import { DiagnosisReportProps } from './reportHelper';
import { ClinicHeader, tableCellStyle } from '../../../../../utils/reportUtils';

const DiagnosisReport: React.FC<DiagnosisReportProps> = ({ diagnoses }) => {
  return (
    <Box sx={{ p: 5, backgroundColor: '#fff', color: '#333', fontFamily: 'Arial, sans-serif' }}>
      <ClinicHeader />
      <Box component="hr" sx={{ my: 3, borderColor: '#ccc' }} />

      <Typography variant="h6" sx={{ mt: 4, mb: 1, color: '#444' }}>📝 Diagnosis Report</Typography>

      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {['#', 'Diagnosis Code', 'Name', 'Type', 'Doctor', 'Date', 'Notes'].map((header, i) => (
                <TableCell key={i} sx={{ ...tableCellStyle, fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {diagnoses.map((d, i) => (
              <TableRow key={d.id}>
                <TableCell sx={tableCellStyle}>{i + 1}</TableCell>
                <TableCell sx={tableCellStyle}>{d.diagnosis_code}</TableCell>
                <TableCell sx={tableCellStyle}>{d.diagnosis_name}</TableCell>
                <TableCell sx={tableCellStyle}>{d.diagnosis_type}</TableCell>
                <TableCell sx={tableCellStyle}>{d.doctor_name}</TableCell>
                <TableCell sx={tableCellStyle}>
                  {new Date(d.created_on).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}
                </TableCell>
                <TableCell sx={tableCellStyle}>{d.notes || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DiagnosisReport;
